import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpService } from '../../http/services/http-service.service';
import { IResponse } from '../../http/interfaces/response.interface';
import { ILog } from "../models/log"
import { LogType } from "../enums/logType";
import { LoggerHandlerService } from "./logger-handler.service";
import { LOGS_URL } from '../constants/consts';
import { InitializerService } from '../../initializer/initializer.service';

@Injectable()
export class LoggerService {
    private isBrowser: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private loggerHandler: LoggerHandlerService,
        private httpSvc: HttpService,
        @Inject(LOGS_URL) private logsUrl: string,
        private initializer: InitializerService
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.setLoggerHandlingServiceSubscriptions();
    }

    private setLoggerHandlingServiceSubscriptions(): void {
        this.loggerHandler.log.subscribe((message: string) => {
            this.sendLogSync(message, LogType.Info).subscribe(() => {
                this.loggerHandler.logCompleted.next(message);
            }, () => {
                this.loggerHandler.logCompleted.next(message);
            });
        });

        this.loggerHandler.warning.subscribe((message: string) => {
            this.sendLogSync(message, LogType.Warning).subscribe(() => {
                this.loggerHandler.warningCompleted.next(message);
            }, () => {
                this.loggerHandler.warningCompleted.next(message);
            });
        });

        this.loggerHandler.error.subscribe((message: string) => {
            this.sendLogSync(message, LogType.Error).subscribe(() => {
                this.loggerHandler.errorCompleted.next(message);
            }, () => {
                this.loggerHandler.errorCompleted.next(message);
            });
        });

        this.loggerHandler.fatal.subscribe((message: string) => {
            this.sendLogSync(message, LogType.Fatal).subscribe(() => {
                this.loggerHandler.fatalCompleted.next(message);
            }, () => {
                this.loggerHandler.fatalCompleted.next(message);
            });
        });
    }

    public log(message: string): void {
        this.sendLog(message, LogType.Info);
    }

    public warning(message: string): void {
        this.sendLog(message, LogType.Warning);
    }
    
    public error(message: string): void {
        this.sendLog(message, LogType.Error);
    }

    public fatal(message: string): void {
        this.sendLog(message, LogType.Fatal);
    }

    public sync = {
        log: (message: string) => {
            return this.sendLogSync(message, LogType.Info);
        },
        warning: (message: string) => {
            return this.sendLogSync(message, LogType.Warning);
        },
        error: (message: string) => {
            return this.sendLogSync(message, LogType.Error);
        },

        fatal: (message: string) => {
            return this.sendLogSync(message, LogType.Fatal);
        }
    }

    private sendLog(message: string, logType: LogType): void {
        if (this.isBrowser) {
            this.httpSvc.post(this.getLogsApiUrl(), this.buildMessage(message, logType)).subscribe((res) => {});
        }
    }

    private sendLogSync(message: string, logType: LogType): Observable<IResponse<null>> {
        if (this.isBrowser) {
          return this.httpSvc.post(this.getLogsApiUrl(), this.buildMessage(message, logType));
        } else {
            return new Observable<IResponse<null>>(observer => {
                observer.next();
            });
        }
    }

    private buildMessage(message: string, logType: LogType): ILog {
        let log: ILog = {
            Message: message,
            Type: logType
        };
        return log;
    }

    private getLogsApiUrl() {
        return this.initializer.getAppConfigs().apiUrl + this.logsUrl;
    }
}
